import _map from 'lodash/map';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_UPDATE_EVENT_STATUS,
  CPM_TRIGGER_CARPARK_DOOR,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { types } from '../../../models/cpm/event';
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmEvent;
const event = (state = initialSettings, action) => {
  let actionResult;
  let operation;

  switch (action.type) {
    case CPM_UPDATE_EVENT_STATUS:
      return {
        ...state,
        list: _map(state.list, (eventElement) => (
          eventElement.id === action.id ? {
            ...eventElement,
            status: action.status,
          } : eventElement
        )),
      };

    case `${CPM_TRIGGER_CARPARK_DOOR}_SUCCESS`:
      /** Create a new event with structure:
        {
          id,
          type: 'doorTrigger',
          status: 'pending',
          data: {
            operationId,
            door
          }
        }
      */
      actionResult = action.data.triggerDoor;
      operation = deserializeOperation(actionResult.operation);
      return {
        ...state,
        list: [...state.list, {
          id: operation.id,
          type: types.doorTrigger,
          status: 'pending',
          data: {
            operationId: operation.id,
            door: { ...action.door },
          },
        }],
      };

    default:
      return state;
  }
};

export default event;



// WEBPACK FOOTER //
// ./reducers/cpm/event/event.js